const PageLoader = () => {
  return (
    <div className="flex min-h-[60vh] w-full items-center justify-center">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#8A9778]/20 border-t-[#8A9778]" />
    </div>
  );
};

export default PageLoader;
